import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeTermsHeaderDesktop } from './desktop';
import { FixedFeeTermsHeaderMobile } from './mobile';
import { FixedFeeTermsHeaderTablet } from './tablet';

export interface FixedFeeTermsHeaderProps {
  onSearch: (value: string) => void;
  onClearSearch: () => void;
  onRefresh: () => void;
  disabled: boolean;
}

export const FixedFeeTermsHeader: React.FC<FixedFeeTermsHeaderProps> = (props) => {
  return useBreakpointValue({
    base: <FixedFeeTermsHeaderMobile {...props} />,
    sm: <FixedFeeTermsHeaderTablet {...props} />,
    lg: <FixedFeeTermsHeaderDesktop {...props} />,
  });
};
